import { render, staticRenderFns } from "./QuotationDisplayView.vue?vue&type=template&id=c2956fb8"
import script from "./QuotationDisplayView.vue?vue&type=script&lang=js"
export * from "./QuotationDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports